<template>
  <div>
    <span v-if="user.role == 'dispatch_agent'">
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/dispatch/dashboard">
          <icon name="time" class="mr-2 w-4 h-4" :class="isUrl('dispatch/dashboard') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/dashboard') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/dispatch/todo">
          <icon name="pending" class="mr-2 w-4 h-4" :class="isUrl('dispatch/todo') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/todo') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">To Dispatch <span v-if="task_counts.confirmed > 0" class=" text-red-400 text-sm font-medium rounded-full p-1">{{ task_counts.confirmed }}</span></div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/dispatch/to_cancel">
          <icon name="pending" class="mr-2 w-4 h-4" :class="isUrl('dispatch/to_cancel') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/to_cancel') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">To Cancel <span v-if="task_counts.to_cancel > 0" class=" text-red-400 text-sm font-medium rounded-full p-1">{{ task_counts.to_cancel }}</span></div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/dispatch/done">
          <icon name="square-check" class="mr-2 w-4 h-4" :class="isUrl('/dispatch/done') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/done') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dispatched</div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/dispatch/cancelled">
          <icon name="square-check" class="mr-2 w-4 h-4" :class="isUrl('/dispatch/cancelled') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/cancelled') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Cancelled</div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/dispatch/all">
          <icon name="list-check" class="mr-2 w-4 h-4" :class="isUrl('/dispatch/all') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/all') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">All Orders</div>
        </Link>
      </div>
    </span>
    <span v-else>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/">
          <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
        </Link>
      </div>

<!--      <div class="mb-4">-->
<!--        <Link class="group flex items-center py-3" href="/orders?status=new">-->
<!--          <icon name="new" class="mr-2 w-4 h-4" :class="isUrl('orders?status=new') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />-->
<!--          <div :class="isUrl('orders?status=new') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">New <span v-if="task_counts.new > 0" class=" text-red-400 text-sm font-medium rounded-full p-1">{{ task_counts.new }}</span></div>-->
<!--        </Link>-->
<!--      </div>-->

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/orders?status=new">
          <icon name="new" class="mr-2 w-4 h-4" :class="isUrl('orders?status=new', 'status=new') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('orders?status=new', 'status=new') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">New <span v-if="task_counts.new > 0" class="text-red-400 text-sm font-medium rounded-full p-1">{{ task_counts.new }}</span></div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/orders?status=pending">
          <icon name="time" class="mr-2 w-4 h-4" :class="isUrl('orders?status=pending', 'status=pending') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('orders?status=pending', 'status=pending') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Pending <span v-if="task_counts.pending > 0" class=" text-red-400 text-sm font-medium rounded-full p-1">{{ task_counts.pending }}</span></div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/orders?status=hold">
          <icon name="hourglass" class="mr-2 w-4 h-4" :class="isUrl('orders?status=hold', 'status=hold') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('orders?status=hold', 'status=hold') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">On hold <span v-if="task_counts.followup > 0" class=" text-red-400 text-sm font-medium p-1 rounded-full">{{ task_counts.followup }}</span></div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/orders?all=true">
          <icon name="list-check" class="mr-2 w-4 h-4" :class="isUrl('orders?all=true') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('orders?all=true') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">All Orders</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/orders/cancelled">
          <icon name="cancel" class="mr-2 w-4 h-4" :class="isUrl('orders/cancelled') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('orders/cancelled') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Cancelled</div>
        </Link>
      </div>
      <div class="mb-4" v-if="user.role !== 'manager'">
        <Link class="group flex items-center py-3" href="/orders?status=confirmed">
          <icon name="check" class="mr-2 w-4 h-4" :class="isUrl('orders?status=confirmed') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('orders?status=confirmed') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"></div>
        </Link>
      </div>
      <div style="border-top: 1px solid #000" class="mb-2" v-if="user.role === 'manager'"></div>
      <div class="mb-4" v-if="user.role === 'manager'">
        <Link class="group flex items-center py-3" href="/dispatch/todo">
          <icon name="pending" class="mr-2 w-4 h-4" :class="isUrl('dispatch/todo') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/todo') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">To Dispatch <span v-if="task_counts.confirmed > 0" class=" text-red-400 text-sm font-medium rounded-full p-1">{{ task_counts.confirmed }}</span></div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/dispatch/to_cancel">
          <icon name="pending" class="mr-2 w-4 h-4" :class="isUrl('dispatch/to_cancel') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/to_cancel') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">To Cancel <span v-if="task_counts.to_cancel > 0" class=" text-red-400 text-sm font-medium rounded-full p-1">{{ task_counts.to_cancel }}</span></div>
        </Link>
      </div>

      <div class="mb-4" v-if="user.role === 'manager'" >
        <Link class="group flex items-center py-3" href="/dispatch/done">
          <icon name="square-check" class="mr-2 w-4 h-4" :class="isUrl('/dispatch/done') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/done') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dispatched</div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/dispatch/cancelled">
          <icon name="square-check" class="mr-2 w-4 h-4" :class="isUrl('/dispatch/cancelled') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('dispatch/cancelled') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Cancelled</div>
        </Link>
      </div>

      <div style="border-top: 1px solid #000" class="mb-2"></div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/reports">
          <icon name="graph" class="mr-2 w-4 h-4" :class="isUrl('reports') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('reports') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reports</div>
        </Link>
      </div>

      <div class="mb-4">
        <Link class="group flex items-center py-3" href="/tools/eta_checker">
          <icon name="time" class="mr-2 w-4 h-4" :class="isUrl('tools/eta_checker') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('tools/eta_checker') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">ETA Checker</div>
        </Link>
      </div>

    </span>
    <!--    <div class="mb-4">-->
    <!--      <Link class="group flex items-center py-3" href="/organizations">-->
    <!--        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('organizations') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />-->
    <!--        <div :class="isUrl('organizations') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Organizations</div>-->
    <!--      </Link>-->
    <!--    </div>-->
    <!--    <div class="mb-4">-->
    <!--      <Link class="group flex items-center py-3" href="/contacts">-->
    <!--        <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('contacts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />-->
    <!--        <div :class="isUrl('contacts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Contacts</div>-->
    <!--      </Link>-->
    <!--    </div>-->
    <!--    <div class="mb-4">-->
    <!--      <Link class="group flex items-center py-3" href="/reports">-->
    <!--        <icon name="printer" class="mr-2 w-4 h-4" :class="isUrl('reports') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />-->
    <!--        <div :class="isUrl('reports') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reports</div>-->
    <!--      </Link>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  props: {
    task_counts: Object,
    admin: Boolean,
    user: Object,
  },
  methods: {
    isUrl(...urls) {
      if (urls.length > 1) {
        let currentUrl = document.URL

        return currentUrl.includes(urls[1])
      }

      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
